import React from 'react';
import { ResponsiveGrid } from '@alifd/next';
import PageHeader from '@/components/PageHeader';
import ElevatorServiceFrontDeskList from './components/ElevatorServiceFrontDeskList';

const { Cell } = ResponsiveGrid;

const ElevatorServiceFrontDesk = () => (
  <ResponsiveGrid gap={20}>
    <Cell colSpan={12}>
      <PageHeader
        title="叫梯服務前台"
        breadcrumbs={[
          {
            name: '叫梯服務',
          },
          {
            name: '叫梯服務前台',
          },
        ]}
      />
    </Cell>

    <Cell colSpan={12}>
      <ElevatorServiceFrontDeskList />
    </Cell>
  </ResponsiveGrid>
);

export default ElevatorServiceFrontDesk;
